import createReducer from '../utils/createReducer';
import actions from '../actions/propertyCount';
import {getComponentState} from '../utils/localStorageDataHandler';

const initialState = {};

const actionHandlers = {

    [actions.GET_LISTING_METADATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            listingMetadata: payload.listingMetadata
        };
    },

    [actions.SET_PROPERTY_COUNT_FIELD](state, {payload}) {
        return {
            ...state,
            numberOfProperty: payload.fieldValue
        };
    },

    [actions.VALIDATE_PROPERTY_COUNT_FIELD](state, {payload}) {
        let propertyCountError;
        let enableContinueButton = false;
        if (payload.fieldValue !== '' && payload.fieldValue >= 0) {
            enableContinueButton = true;
        } else {
            propertyCountError = 'ipmob.input.field.required';
        }
        return {
            ...state,
            propertyCountError,
            enableContinueButton
        };
    },

    [actions.LISTING_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.PRE_POPULATE_P_COUNT_LOCAL_STATE](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'propertyCount');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state
        };
    }
};

export default createReducer(actionHandlers, initialState);
